export default __webpack_public_path__ + "static/media/sidebar-1.4d3501ac.jpg";